export const PRODUCT_PHOTO_LIMIT = 3;

export interface ProductPhotoDraft {
  id?: string;
  image_url: string;
  title?: string | null;
  description?: string | null;
  position: number;
}

export function normalizeProductPhotos(
  photos: readonly Partial<ProductPhotoDraft>[] | null | undefined,
  legacyImageUrl?: string | null,
): ProductPhotoDraft[] {
  const normalized = (photos ?? [])
    .filter((photo): photo is Partial<ProductPhotoDraft> & { image_url: string } =>
      typeof photo.image_url === 'string' && photo.image_url.trim().length > 0)
    .map((photo, index) => ({
      id: photo.id,
      image_url: photo.image_url,
      title: photo.title ?? null,
      description: photo.description ?? null,
      position: Number.isInteger(photo.position) ? Number(photo.position) : index,
    }))
    .sort((a, b) => a.position - b.position)
    .slice(0, PRODUCT_PHOTO_LIMIT)
    .map((photo, position) => ({ ...photo, position }));

  if (normalized.length > 0 || !legacyImageUrl) return normalized;
  return [{
    image_url: legacyImageUrl,
    title: null,
    description: null,
    position: 0,
  }];
}

/** Compatibilidade obrigatória: a primeira foto é sempre products.image_url. */
export function primaryProductPhotoUrl(
  photos: readonly Partial<ProductPhotoDraft>[] | null | undefined,
): string | null {
  return normalizeProductPhotos(photos)[0]?.image_url ?? null;
}

export function moveProductPhotoToPrimary(
  photos: readonly ProductPhotoDraft[],
  index: number,
): ProductPhotoDraft[] {
  if (index <= 0 || index >= photos.length) return normalizeProductPhotos(photos);
  const reordered = [...photos];
  const [selected] = reordered.splice(index, 1);
  reordered.unshift(selected);
  return reordered.map((photo, position) => ({ ...photo, position }));
}

export function productPhotoCountLabel(count: number): string {
  return `${count} ${count === 1 ? 'foto' : 'fotos'}`;
}
